module.exports = "/dist/assets/images/safari-pinned-tab.svg";